import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'convertDate'
})
export class ConvertDatePipe implements PipeTransform {

    transform(date: any, args?: any): any {
        if (date === undefined || date.length <= 0 || date === '') {
            return '';
        }

        return date && moment(date).isValid() ? moment(date).format('DD/MM/YYYY HH:mm') : '-';
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/convert-date.pipe.ts